import React from "react";
import classnames from "classnames";
import { GeneralIcon, type GeneralIcons } from "modules/common/components/planr/icon/Generalcon";
import styles from "./ListItem.module.scss";

export interface ListItemProps {
    title: string;
    subtitle?: string;
    /** Иконка слева */
    icon?: GeneralIcons;
    /** Справа: значение, тег, счётчик */
    right?: React.ReactNode;
    /** Есть обработчик — строка нажимается (кнопка со шевроном), иначе просто строка */
    onClick?: () => void;
    /** Шеврон справа; по умолчанию показан у нажимаемых строк */
    chevron?: boolean;
    /** Отрицательное действие («Выйти») — цвет ошибки */
    danger?: boolean;
    disabled?: boolean;
    className?: string;
}

/**
 * Строка списка: иконка, заголовок, подпись, значение справа. Высота не меньше 56 px,
 * нажимаемая строка — настоящая кнопка (клавиатура и скринридер работают сами).
 */
export const ListItem = ({
    title,
    subtitle,
    icon,
    right,
    onClick,
    chevron,
    danger,
    disabled,
    className,
}: ListItemProps) => {
    const showChevron = chevron ?? !!onClick;
    const classes = classnames(styles.item, className, {
        [styles.clickable]: !!onClick,
        [styles.danger]: danger,
    });

    const content = (
        <>
            {icon && <GeneralIcon type={icon} size={24} className={styles.icon} />}
            <span className={styles.body}>
                <span className={styles.title}>{title}</span>
                {subtitle && <span className={styles.subtitle}>{subtitle}</span>}
            </span>
            {right && <span className={styles.right}>{right}</span>}
            {showChevron && <GeneralIcon type="general-chevron-right" size={16} className={styles.chevron} />}
        </>
    );

    if (onClick) {
        return (
            <button type="button" className={classes} onClick={onClick} disabled={disabled}>
                {content}
            </button>
        );
    }

    return <div className={classes}>{content}</div>;
};
